import styled from 'styled-components/macro';
export const StarsList = styled.ul`
  display: flex;
  column-gap: 0.25rem;
`;

export const StarImg = styled.img``;
